import { motion } from 'framer-motion';

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5, ease: 'easeOut' }
};

const Terms = () => {
  return (
    <div data-testid="terms-page">
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <motion.div {...fadeInUp}>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold text-primary mb-6">
              Terms of Service
            </h1>
            <p className="text-muted-foreground mb-8">
              Last updated: 14 March 2026
            </p>

            <div className="prose prose-slate max-w-none space-y-8">
              <section>
                <h2 className="font-heading text-2xl font-bold text-foreground mb-3">1. About Us</h2>
                <p className="text-muted-foreground">
                  Dockside Design is a trading name of Cameron Siviter, a sole trader based in the United Kingdom.
                  Our website is{' '}
                  <a href="https://www.docksidedesign.co.uk" className="text-accent hover:underline">
                    www.docksidedesign.co.uk
                  </a>.
                  You can contact us at{' '}
                  <a href="mailto:support@docksidedesign.co.uk" className="text-accent hover:underline">
                    support@docksidedesign.co.uk
                  </a>.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-foreground mb-3">2. Use of This Website</h2>
                <p className="text-muted-foreground mb-3">
                  By accessing and using this website, you agree to these Terms of Service. If you do not agree, please do not use the site.
                </p>
                <p className="text-muted-foreground">
                  This website is provided for informational purposes and to allow you to enquire about our web design services.
                  You agree to use the site lawfully and not to misuse any features, including contact forms and email subscription.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-foreground mb-3">3. Services</h2>
                <p className="text-muted-foreground mb-3">
                  We offer web design and development services as described on our website. All prices and descriptions
                  are for guidance only and do not constitute a binding offer.
                </p>
                <p className="text-muted-foreground">
                  A formal agreement will be made separately before any paid work begins. Project scope, timeline,
                  and payment terms will be agreed in writing between both parties.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-foreground mb-3">4. Intellectual Property</h2>
                <p className="text-muted-foreground mb-3">
                  All content on this website — including text, images, logos, and design — is owned by
                  Dockside Design or used with permission. You may not reproduce, distribute, or use any content
                  without our prior written consent.
                </p>
                <p className="text-muted-foreground">
                  For client projects, intellectual property ownership will be specified in the individual project agreement.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-foreground mb-3">5. Limitation of Liability</h2>
                <p className="text-muted-foreground mb-3">
                  This website is provided "as is" without warranties of any kind, express or implied.
                  We do not guarantee that the website will be uninterrupted, error-free, or free of viruses.
                </p>
                <p className="text-muted-foreground">
                  To the fullest extent permitted by law, Dockside Design shall not be liable for any indirect,
                  incidental, or consequential damages arising from your use of this website.
                  Nothing in these terms excludes liability for death, personal injury caused by negligence,
                  or fraud.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-foreground mb-3">6. External Links</h2>
                <p className="text-muted-foreground">
                  This website may contain links to third-party websites. We are not responsible for the content,
                  privacy practices, or availability of those sites.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-foreground mb-3">7. Privacy</h2>
                <p className="text-muted-foreground">
                  Your use of this website is also governed by our{' '}
                  <a href="/privacy" className="text-accent hover:underline">Privacy Policy</a>,
                  which explains how we collect and use your personal data.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-foreground mb-3">8. Governing Law</h2>
                <p className="text-muted-foreground">
                  These terms are governed by the laws of England and Wales. Any disputes will be subject
                  to the exclusive jurisdiction of the courts of England and Wales.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-foreground mb-3">9. Changes to These Terms</h2>
                <p className="text-muted-foreground">
                  We may update these terms from time to time. Any changes will be posted on this page with an updated date.
                  Continued use of the website after changes constitutes acceptance of the revised terms.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-bold text-foreground mb-3">10. Contact</h2>
                <p className="text-muted-foreground">
                  If you have any questions about these terms, contact us at{' '}
                  <a href="mailto:welcome@docksidedesign.co.uk" className="text-accent hover:underline">
                    welcome@docksidedesign.co.uk
                  </a>.
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
